// document.addEventListener('DOMContentLoaded', async () => {
//   try {
//     var mainOfferTitle = document.querySelector('.quick-cart__item.offer-product .quick-cart__item-title a');
//     console.log(mainOfferTitle); // Log mainOfferTitle to see if it's being correctly selected
    
//     // Check if mainOfferTitle exists and contains text content
//     if (mainOfferTitle && mainOfferTitle.textContent.trim() !== '') {
//         console.log('Main offer title found:', mainOfferTitle.textContent.trim()); // Log the text content of mainOfferTitle
//         var mainOfferTitleText = mainOfferTitle.textContent.trim();
    
//         // Fetch data from the API
//         let getValueResponse = await fetch('https://cpanel.mensabrands.com/ShiprocketETAWidget/public/getValueBYOB', {
//             method: "POST",
//             headers: {
//                 "Accept": "application/json",
//                 "Content-type": "application/json",
//                 "Authorization": `Bearer ${window.sessionToken}`
//             },
//             body: JSON.stringify({
//                 offer_product_title: mainOfferTitleText,
//             })
//         });
    
//         if (!getValueResponse.ok) {
//             console.error('Failed to fetch data from API');
//             throw new Error('Failed to fetch data from API');
//         }
    
//         let getValueData = await getValueResponse.json();
//         console.log(getValueData);
//         // Extract necessary data from the API response
//         var mainOffer = getValueData[0];
//         var mainOfferTitleText = mainOffer.offer_product_title;
//         var mainOfferHref = mainOffer.offer_product_url;
//         var mainOfferPriceText = mainOffer.offer_product_price;
//         var mainOfferSrc = mainOffer.offer_product_image;
//         console.log(mainOfferTitleText);
//     }
//       // Fetch the current cart
//       let response = await fetch('/cart.js');
//       let cart = await response.json();

//       // Sequentially update all cart items
//       for (let item of cart.items) {

//           let updateResponse = await fetch('/cart/change.js', {
//               method: 'POST',
//               headers: {
//                   'Content-Type': 'application/json',
//                   'X-Requested-With': 'XMLHttpRequest'
//               },
//               body: JSON.stringify({
//                   id: item.key, // Use item.key for the unique identifier
//                   quantity: item.quantity,
//                   offerPrice: item.properties.price,
//                   offerImage: item.properties.image,
//                   quantity: item.quantity,
//                   properties: {
//                       'Offer': mainOfferTitleText,
//                       'Price': mainOfferPriceText,
//                       'Image': mainOfferSrc,
//                       'PageUrl': mainOfferHref,
//                   }
//               })
//           });

//           if (!updateResponse.ok) {
//               console.error('Failed to update item:', item);
//               throw new Error('Failed to update cart item');
//           }
//       }

//       // Redirect to checkout page after all items are updated
//       // window.location.href = '/checkout';
//   } catch (error) {
//       console.error('Error processing cart:', error);
//   }
// });




window.addEventListener('DOMContentLoaded', () => {
  let slideshowEle = document.querySelectorAll('.slider-wrapper');
  if(slideshowEle) {
    slideshowEle.forEach(current => {
      let swiperOptions = JSON.parse(current.dataset.sliderOptions);
      swiper = new Swiper(current,swiperOptions);

      current.addEventListener('mouseover', () => {
        swiper.autoplay.stop();
      })
      current.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
      })

      // pause slideshow on block select
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          let shopifyData = JSON.parse(e.target.dataset.shopifyEditorBlock),
              targetEle = e.target,
              sliderIndex = 1 + parseInt(targetEle.dataset.swiperSlideIndex);
              swiper.slideTo(sliderIndex);
              swiper.autoplay.stop();
        })
        const customizationEvents = ['shopify:inspector:activate','shopify:inspector:deactivate','shopify:section:load','shopify:block:deselect','shopify:section:reorder','shopify:section:select','shopify:section:deselect','shopify:inspector:activate','shopify:inspector:deactivate'];

        customizationEvents.forEach(event => {
          document.addEventListener(event, () => swiper.init(swiperOptions));  
        })
      }
    })
  }

  // sticky checkout btn
  let checkoutBtn = document.querySelector('.cart__checkout-wrapper');
  if (checkoutBtn && window.innerWidth <= 767) {
    let checkoutBtnClone = document.createElement('div'); 
        checkoutBtnClone.innerHTML = `<div class="sticky-cart-btn">
                                        <button type="button" class="cart__submit btn btn--full btn--primary" id="cloneCheckout">Proceed to checkout</button>
                                      </div>`;
        document.body.appendChild(checkoutBtnClone);
    let cloneCheckoutBtnEle = document.querySelector('.sticky-cart-btn');
    let checkoutBtnObserver = new IntersectionObserver( (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          cloneCheckoutBtnEle.classList.remove('active');
        } else {
          cloneCheckoutBtnEle.classList.add('active');
        }
      });
    })
    checkoutBtnObserver.observe(checkoutBtn);
    cloneCheckoutBtnEle.querySelector('button').addEventListener('click', () => {
      checkoutBtn.querySelector('.btn').click();
    })
  }
  
  window.theme = window.theme || {};


});


document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.querySelector('.offer-add-to-cart .product-form__cart-submit');
  var addToCartButtonText = document.querySelector('.offer-add-to-cart .product-form__cart-submit span');
  var radioButtons = document.querySelectorAll('.button.select-btn');

  var openCart = document.querySelector('.open-cart');
  var closePopup = document.querySelector('.close-popup');
  var popupWrn;

  if (closePopup) {
      closePopup.addEventListener('click', function(event) {
          event.preventDefault();
          popupWrn = document.querySelector('.popup-container.popup-style-2');
          popupWrn.classList.remove('active');
      });
  }

  if (openCart) {
      openCart.addEventListener('click', function(event) {
          event.preventDefault();
          const productConfirmPopEle = document.querySelector('[data-section-id="quick-cart"]');
          const productConfirmPopWrapper = document.querySelector('.quick-cart__wrapper');
          popupWrn = document.querySelector('.popup-container.popup-style-2');
          popupWrn.classList.remove('active');

          if (productConfirmPopWrapper && productConfirmPopEle) {
              productConfirmPopWrapper.classList.add('active');
              productConfirmPopEle.classList.add('animation--quick-cart-revealed');
          }
      });
  }
var replaceButton = document.getElementById('replaceButton');
if (replaceButton) {
    
  replaceButton.addEventListener('click', async function(event) {
      event.preventDefault();
      const divWithPTags = document.querySelector('.quick-cart__form-item-properties p');
      if (divWithPTags) {
          popupWrn = document.querySelector('.popup-container.popup-style-2');
          popupWrn.classList.add('active');
          return;
      }
console.log('testing');
      replaceButton.classList.add('spinning');
      var selectedRadioData = [];
      var total = 0;

      radioButtons.forEach(function(radioButton) {
          if (radioButton.checked) {
              var radioData = radioButton.getAttribute('data-id-variant');
              var priceCurrent = radioButton.getAttribute('data-price-variant');
              var priceNumeric = parseFloat(priceCurrent);
              total += priceNumeric;
              selectedRadioData.push(radioData);
          }
      });

      var productIds = selectedRadioData;
      var mainOfferPrice = parseFloat(document.querySelector('.psptem').textContent.replace(/[^0-9.-]+/g,""));
      let totalPrice = total;
      let offerPrice = mainOfferPrice;
      const currentDate = new Date();
      const formattedDate = currentDate.getFullYear().toString() +
                            (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                            currentDate.getDate().toString().padStart(2, '0');
      
      const hashFormate = String(offerPrice.toString() + formattedDate);


      

      var hashResult =  CryptoJS.MD5(hashFormate).toString(CryptoJS.enc.Hex);
      try {
          let response = await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/discountGenerate', {
              method: "POST",
              headers: {
                  "Accept": "application/json",
                  "Content-type": "application/json",
                  "Authorization": `Bearer ${window.sessionToken}`
              },
              body: JSON.stringify({
                  variant_IDs: productIds,
                  total_price: totalPrice,
                  offer_price: offerPrice,
                  htop: hashResult,
                store_name: "BotanicHearth",
              })
          });
          let res = await response.json();
          let discount_code = res['Discount code'];
          console.log('discount_code');
          console.log(discount_code);
          let discountResponse = jQuery.ajax({
            url: `/discount/${discount_code}`,
            method: 'GET',
                success: function() {
                  console.log('success done');
              }
          });
          if (discountResponse.ok) {
            openDrawer();
            var checkoutBtn = document.querySelector('.quick-cart__submit');
            if (checkoutBtn) {
                checkoutBtn.addEventListener('click', checkoutProcess);
            }
          }
      } catch (error) {
          console.error('Error:', error);
      }
  });
}

  function openDrawer() {
      const productConfirmPopEle = document.querySelector('[data-section-id="quick-cart"]');
      const productConfirmPopWrapper = document.querySelector('.quick-cart__wrapper');
      setTimeout(function() {
          productConfirmPopWrapper.classList.add('active');
          productConfirmPopEle.classList.add('animation--quick-cart-revealed');
      }, 500);

      var discountRow = document.querySelector('li.quick-cart__item-discount');
      // if (discountRow) {
      //     discountRow.innerHTML = "Applied";
      // }

      addToCartButtonText.innerHTML = "Created";
      addToCartButton.classList.remove('spinning');
  }

  async function checkoutProcess(event) {

      try {
      event.preventDefault();
          var checkoutBtn = document.querySelector('.quick-cart__submit');
          checkoutBtn.classList.add('spinning');
          let response = await fetch('/cart.js');
          let cart = await response.json();

          var mainOfferTitle = document.querySelector('.quick-cart__item.offer-product .quick-cart__item-title a');
          if (!mainOfferTitle) {
              checkoutBtn.classList.remove('spinning');
              window.location.href = '/checkout';
              return;
          }

          var mainOfferTitleText = mainOfferTitle.textContent;
          var mainOfferUrl = mainOfferTitle.getAttribute('href');
          var mainOfferImage = document.querySelector('.quick-cart__item.offer-product .quick-cart__item-image img');
          var mainOfferSrc = mainOfferImage.getAttribute('src');
          var mainOfferPrice = document.querySelector('.quick-cart__item-price.offer').textContent;

          for (let item of cart.items) {
              if (item.properties && item.properties.Offer) {
                  let updateResponse = await fetch('/cart/change.js', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'XMLHttpRequest'
                      },
                      body: JSON.stringify({
                          id: item.key,
                          quantity: item.quantity,
                          properties: {
                              'Offer': mainOfferTitleText
                          }
                      })
                  });

                  if (!updateResponse.ok) {
                      var quickCartSubmitButton = document.querySelector('.quick-cart__submit');
                      if (quickCartSubmitButton) {
                          quickCartSubmitButton.click();
                      }
                      throw new Error('Failed to update cart item');
                  } else {
                      await fetch('https://cpanel.mensabrands.com/BYOB_latest/public/getValueBYOB', {
                          method: "POST",
                          headers: {
                              "Accept": "application/json",
                              "Content-type": "application/json",
                              "Authorization": `Bearer ${window.sessionToken}`
                          },
                          body: JSON.stringify({
                              offer_product_title: mainOfferTitleText,
                              offer_product_url: mainOfferUrl,
                              offer_product_price: mainOfferPrice,
                              offer_product_image: mainOfferSrc,
                          })
                      });
                  }
              }
          }

          checkoutBtn.classList.remove('spinning');
          window.location.href = '/checkout';
      } catch (error) {
          console.error('Error processing cart:', error);
      }
  }

  function freeShipStatus(selector) {
      const shippingBar = document.querySelector(selector);
      if (shippingBar) {
          const shippingBarTitle = shippingBar.querySelector('.free-shipping-bar__message');
          const cartTotal = parseInt(shippingBar.dataset.cartTotal);
          const thresholdInCents = parseInt(shippingBar.dataset.threshold);
          const successMsg = shippingBar.dataset.freeShippingSuccessMessage;
          const pendingMsg = shippingBar.dataset.freeShippingPendingMessage;
          shippingBar.classList.add('free-shipping-bar--loaded');
          if ((cartTotal / 100) >= thresholdInCents) {
              shippingBar.classList.add('free-shipping-bar--success');
              shippingBarTitle.innerHTML = successMsg;
          } else {
              const calcRemainAmount = Math.abs(thresholdInCents - (cartTotal / 100)).toFixed(2);
              const remainAmount = window.theme.moneyFormat.replace('{{amount}}', `${calcRemainAmount}`);
              var pendMsg = pendingMsg.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainAmount}</span>`);
              shippingBarTitle.innerHTML = pendMsg;

              const progressWidth = ((cartTotal / 100) < thresholdInCents) ? cartTotal / thresholdInCents : 100;
              shippingBar.querySelector('.free-shipping-bar__bar').style.setProperty("--progress-width", `${progressWidth}%`);
          }
      }
  }
});



// discount-code js
document.querySelectorAll('.success-msg-main').forEach(success => {
	success.style.display="none";
})
document.querySelectorAll('.discount-code-desc-inner').forEach(offer => {
	offer.addEventListener('click', (e) => {
		var current = e.currentTarget;
		var nextcurrent = e.currentTarget.nextElementSibling;
		var loaderclass = e.currentTarget.previousElementSibling;
		var discount_code = e.currentTarget.getAttribute('data-id');
		loaderclass.style.display = "flex";
		current.style.display="none";
		fetch(`/discount/${discount_code}`,{
			method: 'GET',
		})
		.then(response => {
			loaderclass.style.display="none";
			current.style.display = "none";
			nextcurrent.style.display = "flex";
      
			setTimeout(function() {
				current.style.display = "block";
				nextcurrent.style.display = "none";
			}, 4000);
		})
	})
}
)

$(document).on('click', '.custom_checkout', function () {
  var var_id = $('[name="id"]').val();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { id: var_id, quantity: 1 },
    success: function (res) {
      window.location.href = '/cart';
    }
  });
});

$(document).on('click', '.cart_drawer-buy-now', function () {


  var productIdInputs = document.querySelectorAll('input[name="product-id"]');
  var productIdValue;
  // Loop through each input element and retrieve its value
  productIdInputs.forEach(function(input) {
       productIdValue = input.value;
  });
  var buttonForm = document.querySelector(' #product_form_'+productIdValue);
var SubButton = buttonForm.querySelector('button[type="submit"]');

SubButton.click();
  const productConfirmPopEle = document.querySelector('[data-section-id="quick-cart"]');
  const productConfirmPopWrapper = document.querySelector('.quick-cart__wrapper');
  
  if (productConfirmPopWrapper && productConfirmPopEle) {
    productConfirmPopWrapper.classList.add('active');
    productConfirmPopEle.classList.add('animation--quick-cart-revealed');
  }
  var btm = document.querySelector("data-product-form .product-form__cart-submit");
  var discountRow = document.querySelector('li.quick-cart__item-discount');
  if (discountRow) {
    discountRow.innerHTML = "Applied";
  }

});

